import React from 'react';
import getResourceLink from '../../../services/mini/getResourceLink';

class LogLineTooltipImage extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            isImgLoaded: null,
        };

        this.showPreview = this.showPreview.bind(this);
        this.onLoad = this.onLoad.bind(this);
        this.onError = this.onError.bind(this);
    }

    showPreview() {
        const {
            log,
            showBigLogImage,
        } = this.props;
        showBigLogImage({ url: getResourceLink(log.screenshotLink) });
    }

    onLoad() {
        this.setState({ isImgLoaded: true });
    }

    onError() {
        this.setState({ isImgLoaded: false });
    }

    render() {
        const {
            log,
        } = this.props;

        const { isImgLoaded } = this.state;

        return <div className={`log-line-tooltip-image ${log.screenshotLink && 'with-image'}`}>
            {log.screenshotLink &&
                <div className={`log-line-tooltip-image_img-holder ${isImgLoaded && 'has-image'}`} onClick={this.showPreview}>
                    <img src={`${getResourceLink(log.screenshotLink)}`}
                        onLoad={this.onLoad}
                        onError={this.onError}
                        className={`${isImgLoaded && 'visible-with-opacity'}`} />
                    {isImgLoaded === false && <div className="log-line-tooltip-image_img-holder_error">Screenshot is not available now, please try again later</div>}
                </div>}
        </div>;
    }
}

export default LogLineTooltipImage;